import { render } from "./AposInputObject.vue?vue&type=template&id=0c5b8f8e&scoped=true"
import script from "./AposInputObject.vue?vue&type=script&lang=js"
export * from "./AposInputObject.vue?vue&type=script&lang=js"

import "./AposInputObject.vue?vue&type=style&index=0&id=0c5b8f8e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5b8f8e"],['__file',"schema/ui/apos/components/AposInputObject.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c5b8f8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c5b8f8e', __exports__)) {
    api.reload('0c5b8f8e', __exports__)
  }
  
  module.hot.accept("./AposInputObject.vue?vue&type=template&id=0c5b8f8e&scoped=true", () => {
    api.rerender('0c5b8f8e', render)
  })

}


export default __exports__